import { render, staticRenderFns } from "./edit.support.page.vue?vue&type=template&id=1fa02b8e&"
import script from "./edit.support.page.vue?vue&type=script&lang=js&"
export * from "./edit.support.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports